/* CraftPK minimal redesign - interactions */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(root) {
    var els = (root || document).querySelectorAll('[data-cp-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var d = parseInt(e.target.getAttribute('data-cp-delay') || 0, 10);
          setTimeout(function () { e.target.classList.add('is-in'); }, d);
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function stage(root) {
    root.querySelectorAll('[data-cp-stage]').forEach(function (st) {
      if (st.dataset.ready) return; st.dataset.ready = 1;
      var slides = st.querySelectorAll('.cp-stage__slide');
      var thumbs = st.querySelectorAll('.cp-stage__thumb');
      var tags = st.querySelectorAll('[data-cp-tag]');
      var bar = st.querySelector('.cp-stage__progress');
      var dur = parseInt(st.getAttribute('data-interval') || 5000, 10);
      var i = 0, timer = null, paused = false;
      if (bar) bar.style.setProperty('--cp-dur', dur + 'ms');
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-selected', k === i); });
        tags.forEach(function (t, k) { t.hidden = k !== i; });
        if (bar) { bar.classList.remove('run'); void bar.offsetWidth; if (!paused && !reduce) bar.classList.add('run'); }
      }
      function play() { clearInterval(timer); if (slides.length > 1 && !reduce) timer = setInterval(function () { if (!paused) go(i + 1); }, dur); }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); play(); }); });
      st.addEventListener('mouseenter', function () { paused = true; if (bar) bar.classList.remove('run'); });
      st.addEventListener('mouseleave', function () { paused = false; go(i); play(); });
      var sx = null;
      st.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      st.addEventListener('touchend', function (e) {
        if (sx === null) return; var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); play(); } sx = null;
      });
      var main = st.querySelector('.cp-stage__main');
      if (main && !reduce && window.matchMedia('(hover:hover)').matches) {
        main.style.transition = 'transform .5s cubic-bezier(.22,.61,.36,1)';
        main.addEventListener('mousemove', function (e) {
          var r = main.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
          main.style.transform = 'perspective(900px) rotateY(' + (x * 5) + 'deg) rotateX(' + (-y * 5) + 'deg)';
        });
        main.addEventListener('mouseleave', function () { main.style.transform = ''; });
      }
      go(0); play();
    });
  }

  function tabs(root) {
    root.querySelectorAll('[data-cp-tabs]').forEach(function (wrap) {
      if (wrap.dataset.ready) return; wrap.dataset.ready = 1;
      var btns = wrap.querySelectorAll('.cp-tab');
      var panels = wrap.querySelectorAll('.cp-panel');
      var link = wrap.querySelector('[data-cp-viewall]');
      btns.forEach(function (b, k) {
        b.addEventListener('click', function () {
          btns.forEach(function (x, j) { x.classList.toggle('is-active', j === k); x.setAttribute('aria-selected', j === k); });
          panels.forEach(function (p, j) { p.classList.toggle('is-active', j === k); });
          if (link && b.dataset.url) link.setAttribute('href', b.dataset.url);
        });
      });
    });
  }

  function scrollers(root) {
    root.querySelectorAll('[data-cp-scroller]').forEach(function (wrap) {
      if (wrap.dataset.ready) return; wrap.dataset.ready = 1;
      var track = wrap.querySelector('[data-cp-track]');
      var prev = wrap.querySelector('[data-cp-prev]');
      var next = wrap.querySelector('[data-cp-next]');
      var bar = wrap.querySelector('.cp-row__bar i');
      if (!track) return;
      function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 22 : track.clientWidth * .8; }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= max - 4;
        if (bar) {
          var vis = Math.min(1, track.clientWidth / track.scrollWidth);
          bar.style.width = (vis * 100) + '%';
          bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * ((1 - vis) / vis) * 100 : 0) + '%)';
        }
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function copy(root) {
    root.querySelectorAll('[data-cp-copy]').forEach(function (btn) {
      if (btn.dataset.ready) return; btn.dataset.ready = 1;
      var label = btn.textContent;
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-cp-copy');
        function done() { btn.classList.add('is-done'); btn.textContent = 'Copied!'; setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = label; }, 2200); }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          var t = document.createElement('textarea'); t.value = code; document.body.appendChild(t); t.select();
          try { document.execCommand('copy'); } catch (e) {} document.body.removeChild(t); done();
        }
      });
    });
  }

  function countUp(root) {
    root.querySelectorAll('[data-cp-count]').forEach(function (el) {
      if (el.dataset.ready) return; el.dataset.ready = 1;
      var target = parseFloat(el.getAttribute('data-cp-count')) || 0, suffix = el.getAttribute('data-suffix') || '';
      if (reduce || !('IntersectionObserver' in window)) { el.textContent = target + suffix; return; }
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return; io.disconnect();
        var t0 = null;
        function f(ts) { if (!t0) t0 = ts; var p = Math.min(1, (ts - t0) / 1400); el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))) + suffix; if (p < 1) requestAnimationFrame(f); }
        requestAnimationFrame(f);
      });
      io.observe(el);
    });
  }

  function footer(root) {
    var mq = window.matchMedia('(max-width: 749px)');
    var acc = root.querySelectorAll('[data-cp-acc]');
    function sync() { acc.forEach(function (d) { if (mq.matches) { if (!d.dataset.touched) d.removeAttribute('open'); } else { d.setAttribute('open', ''); } }); }
    acc.forEach(function (d) { var s = d.querySelector('summary'); if (s) s.addEventListener('click', function () { d.dataset.touched = 1; }); });
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync);
    root.querySelectorAll('[data-cp-top]').forEach(function (b) {
      if (b.dataset.ready) return; b.dataset.ready = 1;
      b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
    });
  }

  function nudge() {
    var el = document.querySelector('[data-cp-nudge]');
    if (!el || el.dataset.ready) return; el.dataset.ready = 1;
    var closed = false;
    try { closed = sessionStorage.getItem('cpNudgeClosed') === '1'; } catch (e) {}
    if (closed) return;
    var items = el.querySelectorAll('[data-cp-nudge-item]');
    var i = 0, paused = false, delay = parseInt(el.getAttribute('data-delay') || 8000, 10);
    function show() { el.hidden = false; requestAnimationFrame(function () { el.classList.add('is-in'); }); }
    function next() {
      if (paused || items.length < 2) return;
      el.classList.add('is-swap');
      setTimeout(function () {
        items[i].hidden = true; i = (i + 1) % items.length; items[i].hidden = false;
        el.classList.remove('is-swap');
      }, 250);
    }
    setTimeout(function () { show(); setInterval(next, 7000); }, Math.max(4000, delay));
    el.addEventListener('mouseenter', function () { paused = true; });
    el.addEventListener('mouseleave', function () { paused = false; });
    el.querySelector('[data-cp-nudge-close]').addEventListener('click', function () {
      el.classList.remove('is-in');
      setTimeout(function () { el.remove(); }, 300);
      try { sessionStorage.setItem('cpNudgeClosed', '1'); } catch (e) {}
    });
  }

  function init(root) { root = root || document; reveal(root); stage(root); tabs(root); scrollers(root); copy(root); countUp(root); footer(root); nudge(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();